import React from 'react';

import { FlexRow } from '@editor/components/utilities/layouts';
import { withEventScope } from '@repo/event-processor';
import { Button, secondaryTheme } from '@repo/ui/components/Buttons';
import { Spacer } from '@repo/ui/components/Spacer';
import { H2, P2 } from '@repo/ui/components/Typography';

import { formatMonetaryValue } from '../../../../utils/billing';
import CalendarIcon from '../../../utilities/icons/CalendarIcon';

import { ButtonSubtitle } from './styles';
import { SwitchToMonthlyContentProps } from './types';

const SwitchToMonthlyContent: React.FC<SwitchToMonthlyContentProps> = ({
  monthlyPrice,
  onPayMonthly,
  onSubscriptionCancel,
}) => {
  return (
    <>
      <CalendarIcon style={{ alignSelf: 'center' }} />
      <Spacer height="25px" />
      <H2>Switch to monthly subscription</H2>
      <Spacer height="12px" />
      <P2>
        Not sure if you would use Kittl the entire year? Switch to monthly
        subscription and keep the flexibility to pause billing any time.
      </P2>
      <Spacer height="24px" />
      <FlexRow gap="12px" width="100%">
        <Button
          label="Cancel Subscription"
          name="cancelSubscriptionButton"
          theme={secondaryTheme}
          width="100%"
          onClick={onSubscriptionCancel}
        />
        <Button
          label="Pay Monthly"
          name="payMonthlyButton"
          width="100%"
          onClick={onPayMonthly}
        />
      </FlexRow>
      <Spacer height="6px" />
      <FlexRow>
        <ButtonSubtitle>
          Lose access to AI credits, premium content, commercial license and
          more.
        </ButtonSubtitle>
        <ButtonSubtitle>
          {formatMonetaryValue(monthlyPrice, { fractionDigits: 0 })} billed
          monthly
        </ButtonSubtitle>
      </FlexRow>
    </>
  );
};

export default withEventScope(SwitchToMonthlyContent, {
  module: 'switchToMonthlyContent',
});
